/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addUsersToGroups = /* GraphQL */ `
  mutation AddUsersToGroups(
    $customer_code: String!
    $entities_ids: [String!]!
    $groups_ids: [String!]!
  ) {
    addUsersToGroups(
      customer_code: $customer_code
      entities_ids: $entities_ids
      groups_ids: $groups_ids
    ) {
      code
      message
    }
  }
`;
export const enableDisableUser = /* GraphQL */ `
  mutation EnableDisableUser($customer_code: String!, $email: String!) {
    enableDisableUser(customer_code: $customer_code, email: $email) {
      code
      errors
      message
    }
  }
`;
export const removeUserFromGroup = /* GraphQL */ `
  mutation RemoveUserFromGroup(
    $customer_code: String!
    $entity_id: String!
    $group_id: String!
  ) {
    removeUserFromGroup(
      customer_code: $customer_code
      entity_id: $entity_id
      group_id: $group_id
    ) {
      code
      message
    }
  }
`;
export const sendInvitationEmailCustomer = /* GraphQL */ `
  mutation SendInvitationEmailCustomer(
    $customer_code: String!
    $input: InvitationEmailInput!
  ) {
    sendInvitationEmailCustomer(customer_code: $customer_code, input: $input) {
      code
      errors
      message
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $customer_code: String!
    $input: UpdateCustomerInput!
  ) {
    updateCustomer(customer_code: $customer_code, input: $input) {
      code
      data {
        address
        country
        customer_code
        customer_id
        domain
        email
        name
        phone_number
        status
      }
      message
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $customer_code: String!
    $input: UpdateUserProfileInput!
  ) {
    updateUserProfile(customer_code: $customer_code, input: $input) {
      code
      data {
        active
        address
        assigned_ruts
        cognito_signup
        country
        created
        customer_code
        customer_id
        email
        entity_id
        family_name
        given_name
        groups {
          group_id
          group_name
        }
        last_login_date
        pending
        phone_number
        position
        updated
        user_id
        user_name
      }
      message
    }
  }
`;
export const updateUserSettings = /* GraphQL */ `
  mutation UpdateUserSettings(
    $email: String!
    $language: LanguageEnum
    $searcher: AWSJSON
    $subscriptions: AWSJSON
  ) {
    updateUserSettings(
      email: $email
      language: $language
      searcher: $searcher
      subscriptions: $subscriptions
    ) {
      code
      message
    }
  }
`;
export const updateUserSubscribers = /* GraphQL */ `
  mutation UpdateUserSubscribers(
    $customer_code: String!
    $customer_id: String!
    $subscribers_id: [String!]!
    $user_id: String!
  ) {
    updateUserSubscribers(
      customer_code: $customer_code
      customer_id: $customer_id
      subscribers_id: $subscribers_id
      user_id: $user_id
    ) {
      code
      message
    }
  }
`;
